export default {"src":"/login-app/[GIT_HASH]/_next/static/media/visibility_off.2efe34de.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};